import { Grid, makeStyles, IconButton, Paper, Table, TableCell, TableContainer, TableHead, TableRow, Button, Tooltip, TableBody, TablePagination, FormControlLabel, Switch, Card, TextField, InputAdornment, Select, MenuItem, FormControl, TableSortLabel } from "@material-ui/core";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import React, { useEffect, useState } from "react";
import { NuevaSolicitud } from "./NuevaSolicitud";
import { useDispatch, useSelector } from "react-redux";
import { BuscarSolicitud, BuscarSolicitudPorAfi, FiltrarPorEstadoSemaforo, getSolicitudesComunicacion, setFechaCargaDesde, setFechaCargaHasta, setFechaUltimaModificacionDesde, setFechaUltimaModificacionHasta } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import { AREAS_USUARIOS } from "../../utils/constants";
import { RespuestaSolicitud } from "./RespuestaSolicitud";
import BuscadorEmpresas from "../empresas/BuscadorEmpresas";
import { Search } from "@material-ui/icons";
import { SolicitudesComunicacionItem } from "./SolicitudesComunicacionItem";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useForm } from "../../hooks/useForm";

const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
    },
    input: {
        // padding: 10,
        paddingLeft: 10,
        paddingRight: 10,
        marginLeft: 9
    },
});

let destino;
const stateInitial = {
    idProfesional: null,
    fechaCargaDesde: null,
    fechaCargaHasta: null,
    fechaUltimaModificacionDesde: null,
    fechaUltimaModificacionHasta: null,
};
export const ListadoSolicitudesComunicacion = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const componentRef = React.useRef();

    const { areas: areasUsuario } = useSelector((state) => state.auth);
    const tieneAreaAfiliaciones = areasUsuario.find((area) => area.idArea === AREAS_USUARIOS.NACIONAL);
    const { empresaABM } = useSelector((state) => state.empresas);
    const { solicitudesComunicacion, estadoComunicacionActual } = useSelector((state) => state.comunicacionEmpresas);

    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [page, setPage] = useState(0);
    const [dense, setDense] = useState(true);
    const [abrirModalNuevaConsulta, setAbrirModalConsulta] = useState(false);
    const [abrirModalRespuesta, setAbrirModalRespuesta] = useState(false);
    const [selectItem, setItemSelect] = useState();
    const [textoBuscado, setTextoBuscado] = useState("");
    const [textoBuscadoAfiliaciones, setTextoBuscadoAfiliaciones] = useState("");
    const [orderAsc, setOrderAsc] = useState(true);
    const [colorValue, setColorValue] = useState("");
    const [formValues, , , setearValor] = useForm(stateInitial);
    const { fechaCargaDesde, fechaCargaHasta, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta } = formValues;
    if (tieneAreaAfiliaciones) {
        destino = AREAS_USUARIOS.NACIONAL
    } else {
        destino = AREAS_USUARIOS.MESA_DE_AYUDA
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        dispatch(getSolicitudesComunicacion(estadoComunicacionActual, empresaABM ? empresaABM.cuit : null, destino, fechaCargaDesde, fechaCargaHasta, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta));
    }, [dispatch, estadoComunicacionActual, empresaABM?.cuit, fechaCargaDesde, fechaCargaHasta, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta])

    useEffect(() => {
        dispatch(setFechaCargaDesde(fechaCargaDesde));
        dispatch(setFechaCargaHasta(fechaCargaHasta));

    }, [dispatch, fechaCargaDesde, fechaCargaHasta])


    useEffect(() => {
        dispatch(setFechaUltimaModificacionDesde(fechaUltimaModificacionDesde));
        dispatch(setFechaUltimaModificacionHasta(fechaUltimaModificacionHasta));

    }, [dispatch, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta])
    const handleKeyPress = e => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch(textoBuscado);
        }
    }

    const handleChange = (e) => {
        setTextoBuscado(e.target.value);
    }

    const handleChangeAfiliaciones = (e) => {
        setTextoBuscadoAfiliaciones(e.target.value);
    }

    const handleSearch = (textoBuscado) => {
        dispatch(BuscarSolicitud(textoBuscado));
    }

    const handleSearchAfi = (textoBuscadoAfiliaciones) => {
        dispatch(BuscarSolicitudPorAfi(textoBuscadoAfiliaciones))
    }
    useEffect(() => {
        dispatch(FiltrarPorEstadoSemaforo(colorValue))

    }, [dispatch, colorValue])

    const sortedItems = [...solicitudesComunicacion].sort((a, b) => {
        const fechaA = new Date(a.fecha);
        const fechaB = new Date(b.fecha);
        return orderAsc ? fechaA - fechaB : fechaB - fechaA;
    });
    return (
        <div>
            {
                abrirModalNuevaConsulta && (
                    <NuevaSolicitud
                        open={abrirModalNuevaConsulta}
                        onClose={() => setAbrirModalConsulta(false)}
                    />
                )
            }
            {
                abrirModalRespuesta && (
                    <RespuestaSolicitud
                        open={abrirModalRespuesta}
                        onClose={() => setAbrirModalRespuesta(false)}
                        item={selectItem}
                    />
                )
            }
            <Grid container className={classes.root} justify="center" spacing={1}>
                <Grid item xs={12}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={12} md={3}>
                            <BuscadorEmpresas />
                        </Grid>
                        <Grid item xs={12} md={2} >
                            <Card >
                                <Paper style={{
                                    paddingLeft: 10,
                                    paddingRight: 10
                                }}>
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        label="Buscar por usuario mesa"
                                        name="textoBuscado"
                                        value={textoBuscado}
                                        autoComplete="off"
                                        onChange={handleChange}
                                        onKeyPress={handleKeyPress}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end" style={{ marginTop: -25, marginRight: -10 }}>
                                                    <IconButton
                                                        aria-label="Buscar"
                                                        onClick={() => handleSearch(textoBuscado)}                            >
                                                        <Search />
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                    />
                                </Paper>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={2} >
                            <Card style={{ marginLeft: '0.5rem' }}>
                                <Paper component="form" style={{
                                    paddingLeft: 10,
                                    paddingRight: 10
                                }}>
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        label="Buscar por usuario afiliaciones"
                                        name="textoBuscadoAfiliaciones"
                                        value={textoBuscadoAfiliaciones}
                                        autoComplete="off"
                                        onChange={handleChangeAfiliaciones}
                                        onKeyPress={handleKeyPress}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end" style={{ marginTop: -25, marginRight: -10 }}>
                                                    <IconButton
                                                        aria-label="Buscar"
                                                        onClick={() => handleSearchAfi(textoBuscadoAfiliaciones)}                            >
                                                        <Search />
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                    />
                                </Paper>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Paper style={{ paddingTop: 10, paddingBottom: 10, marginLeft: '0.5rem' }}>
                                <FormControl style={{ marginLeft: '1rem', width: '90%' }}>
                                    <Select
                                        id="colorValue"
                                        value={colorValue}
                                        onChange={(e) => setColorValue(e.target.value)}
                                        label="Estado"
                                        displayEmpty
                                        style={{ padding: '0.6rem' }}
                                    >

                                        <MenuItem value={""}>TODOS</MenuItem>
                                        <MenuItem value={0}>VERDE</MenuItem>
                                        <MenuItem value={1}>ROJO</MenuItem>
                                        <MenuItem value={2}>AMARILLO</MenuItem>
                                    </Select>
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input}>
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Desde (Carga de Solicitud)"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        disabled={Boolean(fechaUltimaModificacionDesde)}
                                        value={
                                            moment(fechaCargaDesde).isValid() ? moment(fechaCargaDesde) : null
                                        }
                                        onChange={(date) => {
                                            setearValor("fechaCargaDesde", date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input}>
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Hasta (Carga de Solicitud)"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        disabled={Boolean(fechaUltimaModificacionDesde)}
                                        value={
                                            moment(fechaCargaHasta).isValid() ? moment(fechaCargaHasta) : null
                                        }
                                        onChange={(date) => {
                                            setearValor("fechaCargaHasta", date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input}>
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Desde (Modificacion de Solicitud)"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        disabled={Boolean(fechaCargaDesde)}
                                        value={
                                            moment(fechaUltimaModificacionDesde).isValid() ? moment(fechaUltimaModificacionDesde) : null
                                        }
                                        onChange={(date) => {
                                            setearValor("fechaUltimaModificacionDesde", date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Paper className={classes.input}>
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Hasta (Modificacion de Solicitud)"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        disabled={Boolean(fechaCargaDesde)}
                                        value={
                                            moment(fechaUltimaModificacionHasta).isValid() ? moment(fechaUltimaModificacionHasta) : null
                                        }
                                        onChange={(date) => {
                                            setearValor("fechaUltimaModificacionHasta", date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container justify="center" className={classes.root} spacing={1}>
                    <Grid item xs={12}>
                        <Paper>
                            <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                                <Table size={dense ? "small" : "medium"} ref={componentRef}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell align="left">Semáforo</TableCell>
                                            <TableCell sortDirection={orderAsc ? 'asc' : 'desc'} onClick={() => setOrderAsc(!orderAsc)} style={{ cursor: 'pointer' }}>
                                                <TableSortLabel
                                                    active={true}
                                                    direction={orderAsc ? 'asc' : 'desc'}
                                                >
                                                    Fecha
                                                </TableSortLabel>
                                            </TableCell>                                          
                                            <TableCell>Fecha Ultima Respuesta Afiliaciones</TableCell>
                                            <TableCell>Fecha Ultima Respuesta Mesa</TableCell>
                                            <TableCell>Cuit</TableCell>
                                            <TableCell>Denominacion</TableCell>
                                            <TableCell>Nombre Usuario</TableCell>
                                            <TableCell>Nombre Usuario Mesa</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell><Button onClick={() => setAbrirModalConsulta(true)}><Tooltip title="Nueva Consulta"><AddCircleIcon color='primary' fontSize="large" /></Tooltip></Button></TableCell>
                                            <TableCell>Seguimiento</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sortedItems?.length > 0 ? (
                                            sortedItems
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((item) => (
                                                    <SolicitudesComunicacionItem
                                                        item={item}
                                                        key={item.id.toString()}
                                                        estadoActual={estadoComunicacionActual}
                                                        setItemSelect={setItemSelect}
                                                        setAbrirModalRespuesta={setAbrirModalRespuesta}
                                                    />
                                                ))
                                        ) : (
                                            <TableRow style={{ height: 50 }}>
                                                <TableCell
                                                    colSpan={13}
                                                    style={{ textAlign: "-webkit-center" }}
                                                >
                                                    {" "}
                                                    Sin Registros
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        {solicitudesComunicacion?.length > 0 && (
                            <Grid item xs={12}>
                                <TablePagination
                                    style={{ backgroundColor: "white" }}
                                    rowsPerPageOptions={[1, 5, 10, 25]}
                                    component="div"
                                    count={solicitudesComunicacion.length}
                                    rowsPerPage={rowsPerPage}
                                    labelRowsPerPage="Registros por página"
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={dense}
                                            onChange={(e) => setDense(e.target.checked)}
                                        />
                                    }
                                    label="Tamaño compacto"
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};